import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function () {

  $('.header .nav').hover(function(e){
    $('.header').addClass('nav_hover')
  },function(){
    $('.header').removeClass('nav_hover')
  })
  $('.header .nav ul li').hover(function(e){
    let hasSubnav = $(e.target).closest('li').find('.sub-nav').length > 0

    if(hasSubnav){
      if(!$('.header').hasClass('hover')){
        $('.header').addClass('hover')
      }
    }else{
      $('.header').removeClass('hover')
    }
    
  },function(){
    $('.header').removeClass('hover')
  })

  //pc端菜单，product轮播
  var proNav = $('.header .pro-nav .t2 a')
  var menuswiper1 = new Swiper(".header .pro-swiper .mySwiper", {
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    on: {
      init: function(swiper){
        // $(proNav[this.realIndex]).addClass('active')
      },
      slideChangeTransitionStart: function(){
        // $('.header .pro-nav .t2 a').removeClass('active')
        // $(proNav[this.realIndex]).addClass('active')
      },
    }
  })
  proNav.each(function(index){
    $(this).hover(function(){
      $('.header .pro-nav .t2 a').removeClass('active')
      $(this).addClass('active')
      menuswiper1.slideTo(index)
    })
  })

  //pc端菜单，Sectors轮播
  var menuswiper2 = new Swiper(".header .sec-swiper .mySwiper", {
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    on: {
      init: function(swiper){
        $('.header .sec-nav .item').eq(this.realIndex).addClass('active')
      },
      slideChangeTransitionStart: function(){
        $('.header .sec-nav .item').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    }
  })
  $('.header .sec-nav .item').hover(function(){
    let index = $(this).index()
    menuswiper2.slideTo(index)
  })

  $('.header .sec-news>div').hover(function(){
    let index = $(this).index()
    $('.header .sec-evens>a').eq(index).addClass('active').siblings().removeClass('active')
  })
  

  // 移动端菜单
  $('[data-open="cmenu"]').on('click', function () {
    if($('header .hamburger').hasClass('active')){
      $('header .hamburger').removeClass('active')
      $('header .mob-header').removeClass('show')
      $('.header').removeClass('show-menu')
      $('header .menu-mask').fadeOut(200)
      $('body').css({
        'height':'auto',
        'overflow-y':'auto'
      })
    }else{
      $('header .hamburger').addClass('active')
      $('header .mob-header').addClass('show')
      $('.header').addClass('show-menu')
      $('header .menu-mask').fadeIn(200)
      $('body').css({
        'height':'100vh',
        'overflow-y':'hidden'
      })
    }
  })
  $('.mob-header ul li .sub-nav a').on('click',function(){
    setTimeout(function(){
      $('header .hamburger').removeClass('active')
      $('header .mob-header').removeClass('show')
      $('header .menu-mask').fadeOut(200)
      $('body').css({
        'height':'auto',
        'overflow-y':'auto'
      })
    },200)
  })
  $('.mob-header ul li .title .iconfont').on('click',function(){
    let $parentEl = $(this).parents('li')
    if($parentEl.hasClass('active')){
      $parentEl.removeClass('active')
      $parentEl.find('.sub-nav').slideUp()
    }else{
      $parentEl.addClass('active').siblings().removeClass('active')
      $parentEl.find('.sub-nav').slideDown()
      $parentEl.siblings().find('.sub-nav').slideUp()
    }
  })
  $('.mob-header ul li').each(function(index){
    if($(this).find('.sub-nav a').length > 0){
      $(this).find('.title .iconfont').css('display','flex')
    }
  })

  // 搜索
  var mouseover_tid = [];
  var mouseout_tid = [];
  $(".header-search").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
          let winW = $(window).width()
          if(winW > 1024){
            if(!$('.header-search').hasClass('active')){
              $('.header-search').addClass('active')
              $('#pc-search-input').focus()
            }
          }
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
          let winW = $(window).width()
          if(winW > 1024){
            if($('.header-search').hasClass('active')){
              $('.header-search').removeClass('active')
              $('#pc-search-input').blur()
            }
          }
        }, 500);
      });
    });

  $('#open-search').on('click',function(){
    $('.mob-search').addClass('active')
    $('#mob-search-input').focus()
  })
  $('.mob-search .search-close').on('click',function(){
    $('.mob-search').removeClass('active')
    $('#mob-search-input').blur()
  })
  
});



$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  var contentH = $(document).height(); //内容高度

  if(scroH > 100){
    $('.header').addClass('scroll')
  }else{
    $('.header').removeClass('scroll')
  }
});
